import { FormTable, SheetForm, TgkAmountObjectSource } from "../../interfaces/CoObject";
import { ExcelComponentProps } from "./ExcelAmountSourcePanel";
import React, { useEffect, useState } from "react";
import { CoObjectSourcePanelStateData } from "../co-table-panel/CoObjectSourceTablePanel";
import { IChoiceGroupOption, IComboBoxOption } from "@fluentui/react";
import { FormTreeSelection } from "../../cpm/FormTree";
import { InputAreaSelectionEnum } from "../../../utils/constants/InputAreaSelectionEnum";

const useExcelAmountSourcePanel = (props: ExcelComponentProps) => {
  const {
    objectSource,
    updateCoObjectSourceAmount,
    validateSource,
    isFileExcelExisting,
    fileExcelName,
    updateFileExcelName,
    isComponentInstance,
    isLocked,
  } = props;
  const [stateData, setStateData] = React.useState<CoObjectSourcePanelStateData>();
  const [sheetsAreaChartMap] = useState(new Map<string, string[]>());
  const areaOptions: IChoiceGroupOption[] = [
    { key: InputAreaSelectionEnum.AREA_NAME.description, text: "Select area" },
    { key: InputAreaSelectionEnum.CELL.description, text: "Custom selection" },
  ];
  const [selectedAreaOption, setSelectedAreaOption] = useState("");
  const [isOldValueForAreaToHide, setIsOldValueForAreaToHide] = useState<boolean>(true);
  const [hasSheetToBeSelected, setHasSheetToBeSelected] = useState<boolean>(false);
  const [isLoadingDataExcel, setIsLoadingDataExcel] = useState<boolean>(false);

  useEffect(() => {
    objectSource.cell
      ? setSelectedAreaOption(InputAreaSelectionEnum.CELL.description)
      : setSelectedAreaOption(InputAreaSelectionEnum.AREA_NAME.description);
    setStateData({
      areasItems: [],
      loading: true,
    });
  }, []);

  const onFileClick = (formSelection: FormTreeSelection) => {
    sheetsAreaChartMap.clear();
    const formTable = {
      code: formSelection.formCode,
      desc: formSelection.formDesc,
      oid: formSelection.key,
      oidPath: formSelection.oidPath,
    } as FormTable;

    const obj = {
      ...objectSource,
      form: formTable,
      sheet: null,
      area: null,
      cell: null,
      path: formSelection.oidPath,
      dbApplication: { id: null, desc: null },
      dimensions: [],
    } as TgkAmountObjectSource;

    updateCoObjectSourceAmount(obj, validateSource(obj), true);
  };

  const initAreas = (sheet: SheetForm) => {
    if (sheetsAreaChartMap) {
      sheetsAreaChartMap.forEach((value: string[], key: string) => {
        if (sheet && sheet.code == key) {
          const areaMap: IComboBoxOption[] = value.map((area) => {
            return createIComboBoxFromAreas(area);
          });
          setStateData({
            ...stateData,
            areasItems: areaMap,
          });
        }
      });
    }
  };

  const createIComboBoxFromAreas = (areaValue: string): IComboBoxOption => {
    return {
      key: areaValue,
      text: areaValue,
    };
  };

  const selectSheetComboBox = (option: IComboBoxOption) => {
    const obj = {
      ...objectSource,
      sheet: { code: String(option.key), desc: option.text, uid: null },
      area: null,
      cell: null,
      dbApplication: { id: null, desc: null },
      dimensions: [],
    } as TgkAmountObjectSource;

    updateCoObjectSourceAmount(obj, validateSource(obj), true);
    initAreas({ code: String(option.key), desc: option.text } as SheetForm);
  };

  const changeAreaSelection = (_: React.SyntheticEvent<HTMLElement>, option: IChoiceGroupOption) => {
    setSelectedAreaOption(option.key);
    const obj = {
      ...objectSource,
      area: null,
      cell: null,
      dbApplication: { id: null, desc: null },
      dimensions: [],
    } as TgkAmountObjectSource;
    updateCoObjectSourceAmount(obj, validateSource(obj), true);
  };

  const selectAreaComboBox = (option: IComboBoxOption) => {
    const obj = {
      ...objectSource,
      area: { name: String(option.key) },
      cell: objectSource.cell,
      dbApplication: { id: null, desc: null },
      dimensions: [],
    } as TgkAmountObjectSource;
    updateCoObjectSourceAmount(obj, validateSource(obj), true);
  };

  const selectAmountFromExcelCell = (cellName: string) => {
    const obj = {
      ...objectSource,
      area: { name: null },
      cell: cellName,
      dbApplication: { id: null, desc: null },
      dimensions: [],
    } as TgkAmountObjectSource;
    updateCoObjectSourceAmount(obj, validateSource(obj), true);
  };

  return {
    objectSource,
    onFileClick,
    selectSheetComboBox,
    initAreas,
    sheetsAreaChartMap,
    selectedAreaOption,
    areaOptions,
    changeAreaSelection,
    selectAreaComboBox,
    selectAmountFromExcelCell,
    isFileExcelExisting,
    fileExcelName,
    updateFileExcelName,
    isComponentInstance,
    isLocked,
    setIsOldValueForAreaToHide,
    isOldValueForAreaToHide,
    hasSheetToBeSelected,
    setHasSheetToBeSelected,
    isLoadingDataExcel,
    setIsLoadingDataExcel,
  };
};

export default useExcelAmountSourcePanel;
